const LabMainPage = () => {
  return (
    <div className="powerBiContainer">
      <iframe
        src={`https://app.powerbi.com/view?r=eyJrIjoiYThkZGJjYWUtODkxNi00YTM3LWFkODEtNTU1MzBjYjAwOTE4IiwidCI6IjczM2E0OGI0LTQyYjUtNDM3NC04MDJlLWMzN2U2YzZkNWUwYiIsImMiOjh9`}
        title={'Lab powerBi'}
        width={'100%'}
        height={'100%'}
        allowFullScreen
        sandbox="allow-same-origin allow-scripts allow-forms"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};

export default LabMainPage;
